import { getChatPersonalizationApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ChatPersonalizationApiEditOperatorChatMessageRequest } from '@/core/generated/api';

/** Сохраняет правки собственных ответов оператора */
export const chatMessageEditService = {
    /** Отправляет новую версию ответа поддержки */
    async edit(request: ChatPersonalizationApiEditOperatorChatMessageRequest): Promise<void> {
        try {
            await getChatPersonalizationApi().editOperatorChatMessage(request);
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
